import http from "../utils/http";
export default{
    createRole:function(data,fun){
        http.post("/role",data,fun)
    }, 
    getRole:function(data,fun){
        http.get("/role/page",data,fun)
    }, 
    permissionTree:function(data,fun){
        http.get("/permission/tree",data,fun)
    },
    permissionOfRole:function(id,fun){
        http.get("/role/permission-of-role/"+id,fun)
    },
    removeRole:function(roleId,fun){
        http.delete("/role/"+roleId,fun)
    }, 
    setRolePermission:function(data,fun){
        http.put("/role/put-role-permission",data,fun)
    },   
    signout:function(fun){
        http.delete("/auth/signout",fun)
    },
    getUser(userId, fun) {
        http.get(`/user/${userId}`,fun)
    },
    getRoleOfUser(userId, fun) {
        http.get(`/user/role-of-user/${userId}`,fun)
    }
} 